<template>
  <span v-if="showTooltip">
    <div class="delivery-time-tooltip-container">
      <div class="delivery-time-tooltip">{{ message }}</div>
      <slot></slot>
    </div>
  </span>
  <span v-else>
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'DeliveryTimeTooltip',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  computed: {
    showTooltip() {
      return Boolean(this.message);
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.delivery-time-tooltip-container {
  position: relative;
  display: inline-block;
  color: var(--coral);
  font-family: var(--font-bold);
  line-height: 1;
  cursor: pointer;
  border-bottom: 1px dotted var(--coral);

  .delivery-time-tooltip {
    display: none;
    width: auto;
    max-width: 100%;
    text-align: left;
    padding: var(--space-3);
    font-size: var(--font-size-12);
    line-height: var(--line-height-12);
    background: var(--white);
    color: var(--font-color);
    font-family: var(--font-light);
    z-index: 30;
    position: absolute;
    bottom: 200%;
    right: 0;
    border-radius: var(--space-1);
    box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);
    white-space: normal;

    @media (min-width: 375px) {
      max-width: none;
      width: 160px;
    }

    @media (min-width: 970px) {
      width: 230px;
    }
  }

  &:hover {
    .delivery-time-tooltip {
      display: block;
    }
  }
}
</style>
